import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Saves the server-rendered unread notifications count into localStorage
// AND mirrors it to the native side instantly (over the existing nav-bar
// bridge component), so the native bell badge is already correct the
// moment the user navigates back to the dashboard — no waiting, no flash.
//
// The count always comes from the server (rendered into the data attribute);
// this controller never computes anything — it only stores the latest value.
export default class extends BridgeComponent {
  static component = "nav-bar"
  static values = { count: Number }

  connect() {
    super.connect()
    localStorage.setItem("unread_notifications_count", this.countValue)
    this.send("updateCounts", { badgeCount: this.countValue })
  }
}
